// extracted by mini-css-extract-plugin
module.exports = {"component":"multi-select-component--2fZQS"};